import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4ruezpily0: FaireBrandEntity = {
  token: "b_4ruezpily0",
  type: "brand",
  name: "Tango",
  avatarUrl:
    "https://cdn.faire.com/fastly/33971f9fdcc9cebc5504b11498e62f5a28452aa3f3f4c382281f3ee76c06c54e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/14080fc7730abbe7df70589e9fca91e16f85d4f35f85ebb626d97fc7a55c6c67.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/33971f9fdcc9cebc5504b11498e62f5a28452aa3f3f4c382281f3ee76c06c54e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/14080fc7730abbe7df70589e9fca91e16f85d4f35f85ebb626d97fc7a55c6c67.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 12,
  isInsider: true,
  description:
    "When my grandma crafted her legendary chilé in 1940s Honduras, she used seven simple ingredients— most of them growing naturally right outside her home. It all started with a wild pepper plant beneath the kitchen window, the kind neighborhood kids learned about the hard way. Every season it produced ripe hot Scotch Bonnets, and those fiery childhood encounters became the spark for the chile sauce she later made for the family table.\n\nHer chilé stayed small at first— shared just with family, neighbors, and anyone asking for a little extra to take home. She later gave into friendly pressures to bottle it for the local market, where it quickly found its audience. But she moved to America shortly after, and the recipe went quiet.\n\nFast forward 7 decades later, Brooklyn 2015, she dug up the recipe and made some. It was a flavor I could no longer live without, so she taught me the recipe, I shared it with friends and local shops, it was a hit, and Tango was born. \n\nToday we make Tango in sunny Southern California, one small batch at a time— protecting the flavor, the craft, and the values she started with.   We still haven’t compromised, and its not in the forecast. Same simple, fresh, whole ingredients. Same attention to detail and quality. There's no shortcuts in getting the Tango flavor exactly right. Your satisfaction guaranteed.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:55.758Z",
    importedBy: "entity-db-cli",
  },
};
